<script>
import Layout from "../../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { customertypeService } from "../../../../../services/settingservice/configurationservice/customertype.service";
import List from "../../../../../components/list";
import i18n from "../../../../../i18n";
/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  page: {
    title: "Customer Type List",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, List },
  data() {
    return {
      customerTypeList: {},

      fetchingStats: false,
      title: "Customer Type List",

    };
  },
  mounted() {
    
    this.loadingData();
  },

  methods: {
    loadingData: function(param = '') {
      this.fetchingStats = false;
      customertypeService.getList(param)
        .then(response => {
          
          this.fetchingStats = true;
          this.customerTypeList = response;
        });
    },

    deleted: function(id) {
      customertypeService.remove(id)
        .then(response => {
        
          // this.customerData = response;
          if(response.status == 200) {
            this.$swal.fire({
              title: i18n.t('general.confirm.deleted'),
              text: i18n.t('general.confirm.success'),
              icon: "success",
              confirmButtonText: i18n.t('general.ok')
            });
          }
        });
    },

    pageNavigate: function(param) {
      this.loadingData(param);
    },

    submitAdd: function() {
      this.$router.push(this.$route.query.redirectFrom || {
              name: "setting-customer-type-add",
          });
    },

  }
};
</script>

<template>
  <Layout>
    <PageHeader :add="{icon: 'bx bx-add-to-queue bx-tada', title: 'general.new', link: 'setting-customer-type-add'}" :title="$t('setting.configuration.customer-type.text')" />
    <List v-bind:dataList="customerTypeList" 
          v-bind:updating="fetchingStats" 
          v-bind:navigate="pageNavigate"
          v-bind:formats="[]"
          v-bind:fields="[`name: ${$t('setting.configuration.customer-type.name')}`, 
            `name_en: ${$t('setting.configuration.customer-type.name-en')}`]" 
          v-bind:deletes="[deleted, null]"
          v-bind:edit="{link: 'setting-customer-type-edit'}"
          v-bind:filter="{
            search: ['customer_types.name', 'customer_types.name_en'],
            dropdown: []

          }"
          
    />      
  </Layout>
</template>